import { generateIsOverBreakpoint } from '@project/components/utility';

const breakpoints = {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 1024,
    xl: 1440,
};

// eslint-disable-next-line import/prefer-default-export
export const isOverBreakpoint = generateIsOverBreakpoint(breakpoints);
